import { render, staticRenderFns } from "./GlobalRetailers.vue?vue&type=template&id=fce1743a&"
import script from "./GlobalRetailers.vue?vue&type=script&lang=js&"
export * from "./GlobalRetailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports